import { AppState } from "../redux/store";
import { createSelector } from "@ngrx/store";

export const ui_mobileNavOpen = (state: { main: AppState }) =>
  state.main.ui_mobileNavOpen;

export const orderSearchMetadata = (state: { main: AppState }) =>
  state.main.orderSearchMetadata;

export const orders = (state: { main: AppState }) => state.main.orders;

export const currentOrder = (state: { main: AppState }) =>
  state.main.currentOrder;

export const inboxResultsPerPage = (state: { main: AppState }) =>
  state.main.inboxResultsPerPage;

export const stageList = (state: { main: AppState }) => state.main.stageList;

export const urgencyList = (state: { main: AppState }) =>
  state.main.urgencyList;

export const clinicList = (state: { main: AppState }) => state.main.clinicList;

export const doctorList = (state: { main: AppState }) => state.main.doctorList;

export const taskUsersList = (state: { main: AppState }) =>
  state.main.taskUsersList;

export const deliverersList = (state: { main: AppState }) => state.main.deliverersList;

export const distributionWaybills = (state: { main: AppState }) =>
  state.main.distributionWaybills;

export const distributionWaybillsSearchMetadata = (state: { main: AppState }) =>
  state.main.distributionWaybillsSearchMetadata;

export const chatTaskStatusList = (state: { main: AppState }) =>
  state.main.chatTaskStatusList;

export const curRXForm = (state: { main: AppState }) => state.main.curRXForm;

export const rxOpt = (state: { main: AppState }) => state.main.rxOpt;

export const rxItems = (state: { main: AppState }) => state.main.rxItems;

export const userNotifications = (state: { main: AppState }) =>
  state.main.userNotifications;

export const currentChatContact = (state: { main: AppState }) =>
  state.main.currentChatContact;

export const currentChatTask = (state: { main: AppState }) =>
  state.main.currentChatTask;

export const agentTasks = (state: { main: AppState }) => state.main.agentTasks;

export const agentTasksSearchMetadata = (state: { main: AppState }) =>
  state.main.agentTasksSearchMetadata;

export const userSelectedClinicId = (state: { main: AppState }) =>
  state.main.userSelectedClinicId;

export const roleList = (state: { main: AppState }) => state.main.roleList;

export const ui_tabIdList = (state: { main: AppState }) =>
  state.main.ui_tabIdList;

export const ui_activeTabs = (state: { main: AppState }) =>
  state.main.ui_activeTabs;

export const clinicChainList = (state: { main: AppState }) =>
  state.main.clinicChainList;

export const selectedClinicForKpi = (state: { main: AppState }) =>
  state.main.selectedClinicForKpi;

export const agentClinicList = (state: { main: AppState }) =>
  state.main.agentClinicList;

export const selectedSupplyType = (state: { main: AppState }) =>
  state.main.selectedSupplyType;

export const supplyTypesList = (state: { main: AppState }) =>
  state.main.supplyTypesList;

export const generalTaskUsersList = (state: { main: AppState }) =>
  state.main.generalTaskUsersList;

export const ui_direction = (state: { main: AppState }) =>
  state.main.ui_direction;

export const dashboardData = (state: { main: AppState }) =>
  state.main.dashboardData;

export const rxPresetNotes = (state: { main: AppState }) =>
  state.main.rxPresetNotes;

export const agentsList = (state: { main: AppState }) => state.main.agentsList;

export const ui_navigation = (state: { main: AppState }) =>
  state.main.ui_navigation;

export const clinicsDetails = (state: { main: AppState }) =>
  state.main.clinicsDetails;

export const clinicsSearchMetadata = (state: { main: AppState }) =>
  state.main.clinicsSearchMetadata;

export const techIssuesList = (state: { main: AppState }) =>
  state.main.techIssuesList;

export const techiniciansList = (state: { main: AppState }) =>
  state.main.techiniciansList;

export const drProfilesSearchMetadata = (state: { main: AppState }) =>
  state.main.drProfilesSearchMetadata;

export const drProfiles = (state: { main: AppState }) => state.main.drProfiles;

export const systemParams = (state: { main: AppState }) =>
  state.main.systemParams;

export const plantList = (state: { main: AppState }) => state.main.plantList;

export const mngSelectedClinic = (state: { main: AppState }) =>
  state.main.mngSelectedClinic;

export const usersSearchMetadata = (state: { main: AppState }) =>
  state.main.usersSearchMetadata;

export const users = (state: { main: AppState }) => state.main.users;

export const selectedUser = (state: { main: AppState }) =>
  state.main.selectedUser;

export const lastSavedUser = (state: { main: AppState }) =>
  state.main.lastSavedUser;

export const presetNotes = (state: { main: AppState }) =>
  state.main.presetNotes;

export const presetNotesSearchMetadata = (state: { main: AppState }) =>
  state.main.presetNotesSearchMetadata;

export const operationReports = (state: { main: AppState }) =>
  state.main.operationReports;

export const reportsSearchParams = (state: { main: AppState }) =>
  state.main.reportsSearchParams;

export const balanceSearchMetadata = (state: { main: AppState }) =>
  state.main.balanceSearchMetadata;

export const curReportBalanceRows = (state: { main: AppState }) =>
  state.main.curReportBalanceRows;

export const invoicesSearchMetadata = (state: { main: AppState }) =>
  state.main.invoicesSearchMetadata;

export const curReportInvoices = (state: { main: AppState }) =>
  state.main.curReportInvoices;

export const curReportReceipts = (state: { main: AppState }) =>
  state.main.curReportReceipts;

export const receiptsSearchMetadata = (state: { main: AppState }) =>
  state.main.receiptsSearchMetadata;

export const currentReportScreenType = (state: { main: AppState }) =>
  state.main.currentReportScreenType;

export const curTotalDept = (state: { main: AppState }) =>
  state.main.curTotalDept;

export const supplyOrderSearchMetadata = (state: { main: AppState }) =>
  state.main.supplyOrderSearchMetadata;

export const supplyOrders = (state: { main: AppState }) =>
  state.main.supplyOrders;

export const supplySelectedClinic = (state: { main: AppState }) =>
  state.main.supplySelectedClinic;

export const orderEmailTemplates = (state: { main: AppState }) =>
  state.main.orderEmailTemplateList;

export const kpiConfig = (state: { main: AppState }) => state.main.kpiConfig;

export const currentDisplayedFileId = (state: { main: AppState }) =>
  state.main.currentDisplayedFileId;

export const qcModeSw = (state: { main: AppState }) => state.main.qcModeSw;

export const inboxNeedsReload = (state: { main: AppState }) =>
  state.main.inboxNeedsReload;

// Order navigation selectors
export const orderNavNextSw = createSelector(
  orders,
  currentOrder,
  orderSearchMetadata,
  (ordersList, current, metadata) => {
    if (!ordersList || !current) return false;

    let curIdx = ordersList.findIndex(
      (o) => o.orderId == current?.orderId
    );

    // Check if there's a next order in current page
    if (curIdx != -1 && curIdx < ordersList.length - 1) {
      return true;
    }

    // Check if we're on the last order of current page but there are more pages
    if (curIdx == ordersList.length - 1) {
      if (metadata?.totalRecords && metadata?.toRecord) {
        // If toRecord is less than totalRecords, there are more pages
        return metadata.toRecord < metadata.totalRecords;
      }
    }

    return false;
  }
);

export const orderNavPrevSw = createSelector(
  orders,
  currentOrder,
  orderSearchMetadata,
  (ordersList, current, metadata) => {
    if (!ordersList || !current) return false;

    let curIdx = ordersList.findIndex(
      (o) => o.orderId == current?.orderId
    );

    // Check if there's a previous order in current page
    if (curIdx != -1 && curIdx > 0) {
      return true;
    }

    // Check if we're on the first order of current page but there are previous pages
    if (curIdx == 0) {
      if (metadata?.fromRecord && metadata.fromRecord > 1) {
        // If fromRecord is greater than 1, there are previous pages
        return true;
      }
    }

    return false;
  }
);

export const nextOrderOnSamePage = createSelector(
  orders,
  currentOrder,
  (ordersList, current) => {
    if (!ordersList || !current) return false;

    let curIdx = ordersList.findIndex(
      (o) => o.orderId == current?.orderId
    );

    // Check if there's a next order in current page
    return curIdx != -1 && curIdx < ordersList.length - 1;
  }
);